import type { QuestionnaireDefinition } from "./schema";

/** Presentation only; skipping welcome does not authorize campaign attribution. */
export function intakeEntryDefinition(
  definition: QuestionnaireDefinition,
  campaign: boolean,
): QuestionnaireDefinition {
  if (!campaign) return definition;
  const steps = definition.steps.filter(
    (step) =>
      !step.fields.every(
        (field) => field.kind === "page" && field.placement === "start",
      ),
  );
  return { ...definition, steps, initialStepId: steps[0]?.id };
}
